<!--
 * @Author: ken yang
 * @Date: 2022-09-11 16:39:14
 * @LastEditTime: 2022-09-13 14:45:08
 * @LastEditors: ken yang
 * @Description: 
 * @FilePath: \nicee-web-tw\src\activities\crystal-draw\index.vue
-->
<template>
  <div v-if="isPC">
    <!-- 水晶奪寶 -->
    <div class="crystal-draw-content">
      <img class="top-image" src="./images/banner.png" alt="" />
      <!-- 立即抽獎 -->
      <div class="draw-content">
        <div class="draw-progress-container">
          <div
            class="draw-progress-image"
            v-if="gearsInfo && gearsInfo.length > 0"
          >
            <div class="draw-progress-1000" :style="{ left: targetChange(0) }">
              <img class="draw-image-1000" src="./images/max-1000.png" />
              <div class="draw-image-item"></div>
              <div class="draw-1000">
                {{ gearsInfo[0] ? gearsInfo[0].node : 0 }}
              </div>
            </div>
            <div class="draw-progress-3000" :style="{ left: targetChange(1) }">
              <img class="draw-image-3000" src="./images/max-3000.png" />
              <div class="draw-image-item"></div>
              <div class="draw-3000">
                {{ gearsInfo[1] ? gearsInfo[1].node : 0 }}
              </div>
            </div>
            <div class="draw-progress-8000" :style="{ left: targetChange(2) }">
              <img class="draw-image-8000" src="./images/max-8000.png" />
              <div class="draw-image-item"></div>
              <div class="draw-8000">
                {{ gearsInfo[2] ? gearsInfo[2].node : 0 }}
              </div>
            </div>
          </div>
          <div class="draw-container">
            <div class="draw-progress" :style="{ width: progressWidth }">
              <!-- 縂進度條水晶數與開獎獎券闕值 -->
              <span class="draw-target"
                >{{ activityData.ticket }}/{{ activityData.lotteryNum }}</span
              >
            </div>
          </div>
        </div>
        <!-- 擋位獎勵獎券數 -->
        <p class="draw-p">
          當達到{{ target }}目標，擁有獎券的用戶可再得{{ num }}張獎券噢！
        </p>
        <div class="draw-correlation">
          <div class="draw-correlation-item">
            <img src="./images/crystal.png" />
            <!-- 縂水晶數 -->
            <div class="draw-number">{{ activityData.crystalBalance }}</div>
          </div>
          <div class="draw-correlation-item">
            <img src="./images/coupon.png" />
            <!-- 縂獎券數 -->
            <div class="draw-number">{{ activityData.ticketBalance }}</div>
          </div>
        </div>
        <p class="draw-tips">Tips：獎券越多中獎的概率越大噢！</p>
        <img
          src="./images/buttonImmediately.png"
          class="draw-immediately"
          :style="
            isGrayscale
              ? { filter: 'grayscale(0.75)' }
              : { filter: 'grayscale(0)' }
          "
          @click="getDraw"
        />
      </div>
      <div class="draw-info">
        <!-- 活動規則 -->
        <div class="draw-activity-rules">
          <div class="rules-title">
            <img src="./images/rule-title.png" />
          </div>
          <div class="rules-info">
            <p>1. 確認完成訂單後即可獲得水晶啦；</p>
            <p>
              2. 每200水晶可兌換1張獎券，當總券數到達10000時，將停止兌換獎券；
            </p>
            <p>
              3.
              當所有人投入的獎券總共到達10000張時，將從中抽出十張獎券的得主平分10000元現金；
            </p>
            <p>4. 完成陪玩服務訂單：雙方各可獲得訂單金額1倍水晶；</p>
          </div>
          <div class="rules-info-item">
            <p>
              <span class="rules-info-span">送出禮物：</span>
              雙方各可獲得禮物價值折算成Nicee幣之後的兩倍！Nicee幣和鑽石的兌換比例為1：15噢~
            </p>
            <p>
              如：當您下單200元的訂單且確認完成後，您和陪玩師都會獲得200個水晶；當您送陪玩師總價值150鑽石的禮物時，您和陪玩師都會獲得20個水晶！
            </p>
          </div>
          <div class="rules-info-hint">
            （溫馨提示：水晶將在本期活動結束後清空，請務必要即時兌換噢！擁有的獎券越多，中獎幾率越大呢！）
          </div>
        </div>
        <!-- 大獎得主 -->
        <div class="draw-winners">
          <img
            class="draw-winners-title"
            src="./images/winner-title.png"
            alt=""
          />
          <div class="draw-winners-box">
            <div
              v-for="item in winnersInfo"
              :key="item.id"
              class="draw-winners-item"
            >
              <img :src="item.headImage" alt="" />
              <div class="name">{{ item.nickName }}</div>
            </div>
          </div>
        </div>
        <!-- 大獎得主 -->
        <!-- <div class="draw-winners">
          <img src="./images/winner-title.png" />
          <img class="draw-winners-head" src="./images/winner-head.png" />
          <div class="winners-head-circle"> -->
        <!-- 大獎得主相片 -->
        <!-- <img
              v-if="activityData.lastPlayerImage"
              :src="activityData.lastPlayerImage"
            />
          </div> -->
        <!-- 大獎得主姓名 -->
        <!-- <span class="winners-footer">{{
            activityData.lastPlayerNickname
          }}</span>
        </div> -->
      </div>
    </div>
    <!-- 兌換彈窗 -->
    <el-dialog
      title="獎券兌換"
      :visible.sync="showExchangeDialog"
      center
      append-to-body
    >
      <div class="exchange-dialog">
        <div class="exchange-item">
          <span>我有</span>
          <!-- 縂水晶數 -->
          <span class="exchange-crystal-number">{{
            activityData.crystalBalance
          }}</span>
          <img src="./images/min-crystals.png" />
        </div>
        <div class="exchange-container">
          <span class="exchange-container-item">兌換</span>
          <!-- <el-input-number
            v-model="ticketValue"
            :class="{ 'less-crystal-value': isLessCrystalValue }"
            :max="10000"
            :min="null"
            @change="handelChange"
          ></el-input-number> -->
          <el-input
            v-model="ticketValue"
            :max="10000"
            :min="null"
            @input="onInput"
            class="nicee-input-box"
            :class="{ 'less-crystal-value': isLessCrystalValue }"
          >
            <template slot="prefix"
              ><span
                role="button"
                class="el-input-number__decrease"
                @click="deleteNum()"
                ><i class="el-icon-minus"></i></span
            ></template>
            <template slot="suffix"
              ><span
                role="button"
                class="el-input-number__increase"
                @click="addNum()"
                ><i class="el-icon-plus"></i></span
            ></template>
          </el-input>
          <span class="exchange-container-item">張券</span>
        </div>
        <div class="need-container">
          <div
            class="need-crystal"
            :style="{
              'background-color': isLessCrystalValue
                ? 'rgba(255, 40, 195, 0.2)'
                : 'inherit'
            }"
          >
            <span>需要</span>
            <!-- 兌換獎券需要的水晶數 -->
            <span class="need-crystal-number">{{ crystalValue }}</span>
            <span>水晶</span>
          </div>
          <div class="crystal-deficiency" v-if="isLessCrystalValue">
            水晶不足啦，快去下單吧
          </div>
        </div>
        <button class="exchange-butoton" @click="onExchange">兌換</button>
      </div>
    </el-dialog>
  </div>
  <min-crystal v-else></min-crystal>
</template>
<script>
import minCrystal from './min-crystal.vue';
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
export default {
  components: {
    minCrystal
  },
  data() {
    return {
      //兌換彈窗展示
      showExchangeDialog: false,
      // 需要兌換獎券數量
      ticketValue: '',
      //水晶活動的數據
      activityData: {},
      //水晶不足判斷
      isLessCrystalValue: false,
      //獎勵檔位信息
      gearsInfo: [],
      // 大獎得主
      winnersInfo: [
        {
          id: 3309997,
          nickName: 'Abc',
          headImage:
            'https://resource.3uplay.com/user-static/62071758-51d8-4901-8d74-d6c8ab85f1f7.png'
        },
        {
          id: 3626244,
          nickName: '白吃吃吃',
          headImage:
            'https://resource.3uplay.com/user-static/4d46e4a5-621c-4db9-b8b8-6814a9a7d16e4826769374056265524.jpeg'
        },
        {
          id: 315796,
          nickName: 'AbSyü💛隨緣接單c',
          headImage:
            'https://resource.3uplay.com/user-static/f59c4d51-b7fb-4e27-b1be-f06550fc295e353110651574291844.png'
        },
        {
          id: 628899,
          nickName: '顏顏顏顏 新陪·Ⱉ·',
          headImage:
            'https://resource.3uplay.com/user-static/376ea66e-0d6e-4bed-8358-453739104cd26576194274027122987.png'
        },
        {
          id: 1388400,
          nickName: '奈特',
          headImage:
            'https://resource.3uplay.com/user-static/f342e29a-d52c-44af-8a12-5fea9cee0065.png'
        },
        {
          id: 102749,
          nickName: 'Zaya ',
          headImage:
            'https://resource.3uplay.com/user-static/73302628-2beb-483a-a143-75930fd6f2ff1054714939710452903.png'
        },
        {
          id: 101583,
          nickName: '懷中貓🍓在線隨緣接',
          headImage:
            'https://resource.3uplay.com/user-static/e9a67483-a552-451f-98d9-e9f021e4b91b9168412677565174319.png'
        },
        {
          id: 3472215,
          nickName: '不專業的盤子',
          headImage:
            'https://resource.3uplay.com/user-static/c9f195cd-9a90-4ccd-bfa1-63519b80b5513682532474855046315.png'
        },
        {
          id: 251240,
          nickName: 'User111256',
          headImage:
            'https://resource.3uplay.com/user-static/05a90d84-7c4b-449e-be15-739b9ca626c32742479678492580077.png'
        },
        {
          id: 3241618,
          nickName: '且听风吟',
          headImage:
            'https://resource.3uplay.com/user-static/fd3223ef-c63f-4a1e-9468-84698d813fd15680918210282225565.png'
        }
      ]
    };
  },
  methods: {
    //點擊立即抽獎-檢查登錄，彈窗兌換頁面
    async getDraw() {
      // 檢查登錄
      await this.checkLogin();
      if (this.activityData.ticket >= 10000) {
        this.showExchangeDialog = false;
        // this.grayscale = 'grayscale(0.75)';
      } else {
        console.log('點擊立即抽獎，彈窗兌換頁面');
        this.ticketValue = '';
        this.isLessCrystalValue = false;
        this.showExchangeDialog = true;
      }
    },
    // 检查登录
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    //獲取活動信息
    getActivityLotteryInfo() {
      this.$http.get('/activity/getActivityLotteryInfo').then(({ data }) => {
        this.activityData = data;
        this.gearsInfo = JSON.parse(data.gearsInfo);
      });
    },
    //兌換,限制最多10000張
    onExchange() {
      if (this.activityData.crystalBalance >= this.crystalValue) {
        this.postconvertAccount();
        this.getActivityLotteryInfo();
        this.showExchangeDialog = false;
        console.log('兌換');
      } else {
        this.isLessCrystalValue = true;
      }
    },
    //關閉彈窗
    closeExchangeDialog() {
      this.getActivityLotteryInfo();
      this.showExchangeDialog = false;
    },
    //彈窗數據
    postconvertAccount() {
      this.$http
        .post('/account/convertAccount', {
          accountKind: 'Crystal',
          convertAccountKind: 'Ticket',
          convertAmount: this.ticketValue,
          userUuid: this.userInfo.uuid
        })
        .then(() => {
          this.getActivityLotteryInfo();
        });
    },
    //兌換框中不能輸入首位為0的獎券數,不能輸入字符
    onInput() {
      this.ticketValue = this.ticketValue
        .toString()
        .replace(/^(0+)|[^\d]+/g, '');
    },
    // onInput() {
    //   this.ticketValue = this.ticketValue.replace(/^[0]|[-]/g, '');
    //   // this.ticketValue = this.ticketValue.replace(/[-]/g, '');
    // },
    //進度條黃金根據檔位變化
    targetChange(index) {
      const test = `calc(${(this.gearsInfo[index].node /
        this.activityData.lotteryNum) *
        100}% - 21px)`;

      return test;
    },
    deleteNum() {
      this.ticketValue =
        this.ticketValue && this.ticketValue > 1 ? --this.ticketValue : '';
    },
    addNum() {
      this.ticketValue = this.ticketValue ? ++this.ticketValue : 1;
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'refreshToken']),
    //是否展示大獎得主
    // isShowWinners() {},
    //ticket達到10000張，進入抽獎頁面按鈕置灰
    isGrayscale() {
      return this.activityData && this.activityData.ticket >= 10000;
    },
    // 是否已登录状态

    //目標檔位
    target() {
      let index = 0;
      if (this.gearsInfo.length) {
        switch (this.activityData.gearsAward) {
          case this.gearsInfo[0]:
            index = 0;
            break;
          case this.gearsInfo[1]:
            index = 1;
            break;
          case this.gearsInfo[2]:
            index = 2;
            break;
          default:
            index = 2;
            break;
        }
      }
      return this.gearsInfo[index] ? this.gearsInfo[index].node : 0;
    },
    //目標檔位獲得的獎券
    num() {
      let index = 0;
      if (this.gearsInfo.length) {
        switch (this.activityData.gearsAward) {
          case 0:
            index = 0;
            break;
          case 1000:
            index = 1;
            break;
          case 3000:
            index = 2;
            break;
          default:
            index = 2;
            break;
        }
      }
      return this.gearsInfo[index] ? this.gearsInfo[index].award : 0;
    },
    //進度條黃金根據檔位變化
    // targetChange() {
    //   return `calc(${this.target / this.activityData.lotteryNum}% - 42px)`
    // },
    //根據券數自動計算水晶值
    crystalValue() {
      return this.ticketValue * 200;
    },
    //每達到100張，進度條動態變化
    progressWidth() {
      if (this.activityData.ticket >= 100) {
        return (
          Math.round(
            (this.activityData.ticket / this.activityData.lotteryNum) * 10000
          ) /
            100 +
          '%'
        );
      }
      return 0;
    }
    // 抽奖进度条样式
    // progressStyle() {
    //   const list = ['10%', '30%', '80%'];
    //   const styleObj = {
    //     width: this.progressWidth || 0
    //   };
    //   if (list.includes(this.progressWidth)) {
    //     styleObj['border-right'] = `4px solid #FFC700`;
    //   }
    //   return styleObj;
    // }
    // 水晶不足
    // isLessCrystalValue() {
    //   return this.crystalValue > this.activityData.crystalBalance;
    // }
  },
  created() {
    this.getActivityLotteryInfo();
  }
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 600px) {
  .crystal-draw-content {
    width: 100%;
    // background: #f7ffe5 url('./images/background.png') no-repeat center top /
    //   1920px auto;
    background-color: #f7ffe5;
    // padding-top: 474px;
    padding-bottom: 45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    // overflow-x: scroll;
    .top-image {
      width: 980px;
      // padding-bottom: 26px;
      // padding-top: 26px;
    }
    .draw-content {
      width: 980px;
      height: 550px;
      background: url('./images/draw.png') no-repeat;
      font-size: 16px;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      align-items: center;
      .draw-progress-container {
        position: relative;
        padding-top: 76px;
        // .draw-progress-image {
        //   position: absolute;
        //   top: 40px;
        //   left: 100px;
        //   .draw-progress-10000 {
        //     margin-left: 104px;
        //   }
        //   .draw-progress-20000 {
        //     margin-left: 204px;
        //   }
        // }
        .draw-progress-image {
          position: absolute;
          top: 43px;
          left: 66px;
          display: flex;
          font-size: 18px;
          font-weight: 600;
          line-height: 18px;
          text-align: center;
          .draw-progress-1000 {
            margin-right: 132px;
          }
          .draw-progress-3000 {
            margin-right: 394px;
          }
          .draw-progress-1000,
          .draw-progress-3000,
          .draw-progress-8000 {
            width: 42px;
            height: 51px;
            .draw-image-1000 {
              width: 10px;
              height: 28px;
            }
            .draw-image-3000 {
              width: 34px;
              height: 28px;
            }
            .draw-image-8000 {
              width: 45px;
              height: 28px;
            }
            .draw-image-item {
              width: 2px;
              height: 24px;
              background: #ffc700;
              margin: 3px auto 0 auto;
            }
            .draw-1000,
            .draw-3000,
            .draw-8000 {
              margin-top: 4px;
              color: #8f3c00;
            }
          }
        }

        .draw-container {
          width: 870px;
          height: 24px;
          border-radius: 10px;
          background-color: #fff;
          overflow: hidden;
          .draw-progress {
            border-radius: 10px 0 0 10px;
            height: inherit;
            background: #fd68b5;
            transition: width 0.2s linear;
            .draw-target {
              position: absolute;
              top: 79px;
              right: 14px;
              color: #006e5f;
            }
          }
        }
      }
    }

    .draw-correlation {
      width: 100%;
      padding: 0 55px;
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      .draw-correlation-item {
        position: relative;
        .draw-number {
          position: absolute;
          width: 110px;
          height: 30px;
          top: 64px;
          right: 64px;
          line-height: 30px;
          text-align: center;
        }
      }
    }
    .draw-info {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      width: 980px;
      display: flex;
      .draw-activity-rules {
        width: 568px;
        height: 366px;
        background: url('./images/rules.png ') no-repeat;
        vertical-align: top;
        background-size: 100% 366px;
        .rules-title {
          width: calc(100% - 8px);
          height: 70px;
          margin: 0 3px 0 1px;
          padding-left: 36px;
          padding-right: 36px;
          border-bottom: 1px solid #e8eaee;
          display: flex;
          align-items: center;
        }
        .rules-info {
          margin: 20px 0 0 36px;
          > p {
            font-size: 14px;
            font-weight: 600;
            line-height: 21px;
            text-align: left;
          }
        }
        .rules-info-item {
          margin: 20px 0 0 36px;
          margin-top: 8px;
          padding-right: 36px;
          color: #737a92;
          line-height: 21px;
          font-size: 14px;
          .rules-info-span {
            color: #0d183b;
          }
        }
        .rules-info-hint {
          margin: 20px 0 0 36px;
          margin-top: 8px;
          color: #da3c62;
          font-size: 12px;
          line-height: 18px;
        }
      }
      .draw-winners {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: column;
        width: 382px;
        background: url('./images/winners-bg.png') no-repeat;

        // background-color: #ffde69;
        .draw-winners-title {
          margin-top: 46px;
          margin-bottom: 41px;
        }

        .draw-winners-box {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          margin-left: -14px;
          width: 100%;
        }
        .draw-winners-item {
          width: 50px;
          margin-left: 14px;
          margin-bottom: 26px;
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
          .name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
          }
        }
      }
      // .draw-winners {
      //   width: 250px;
      //   height: 290px;
      //   margin-left: 20px;
      //   padding-top: 20px;
      //   background: url('./images/winners.png') no-repeat;
      //   display: flex;
      //   flex-direction: column;
      //   align-items: center;
      //   position: relative;
      //   .draw-winners-head {
      //     margin-top: 14px;
      //   }
      //   .winners-head-circle {
      //     width: 80px;
      //     height: 80px;
      //     border-radius: 80px;
      //     background-color: #fd68b5;
      //     position: absolute;
      //     top: 85px;
      //     right: 134px;
      //   }
      //   .winners-footer {
      //     margin-top: 5px;
      //   }
      // }
    }
  }
  .draw-p {
    margin-top: 46px;
  }
  .draw-tips {
    margin-top: 40px;
  }
  .draw-immediately {
    margin-top: 30px;
  }
}

/deep/ .el-dialog {
  background: #cfeffa url(./images/max-dialog.png) no-repeat center 12px;
  width: 600px;
  height: 430px;
  background-size: 560px 300px;
  border-radius: 14px;
  .el-dialog__title {
    font-size: 28px;
    font-weight: 600;
  }
  .el-dialog__headerbtn {
    margin-right: 10px;
  }
  .el-dialog__body {
    padding-top: 15px;
  }
  .exchange-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    .exchange-item {
      display: flex;
      line-height: 20px;
      > span {
        font-size: 20px;
        font-weight: 600;
      }
      .exchange-crystal-number {
        color: #ffa336;
        font-size: 18px;
        line-height: 18px;
        margin: 0 8px;
      }
    }
    .exchange-container {
      width: 490px;
      height: 70px;
      border: 1px solid;
      border-radius: 70px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      .nicee-input-box {
        &.el-input {
          width: 300px;
          .less-crystal-value {
            .el-input__inner {
              color: #f33333;
            }
          }
          .el-input__inner {
            padding: 0 60px;
            border: none;
            text-align: center;
          }
          .el-input-number__decrease,
          .el-input-number__increase {
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: inline-block;
            line-height: 40px;
          }
        }
      }
      // .less-crystal-value {
      //   .el-input__inner {
      //     color: #f33333;
      //   }
      // }
      .exchange-container-item {
        font-size: 16px;
        font-weight: 600;
      }
      .el-input-number {
        width: 200px;
        margin: 0px 30px;
      }
      // .el-input-number__increase,
      // .el-input-number__decrease,
      // .el-input__inner {
      //   border-radius: 20px;
      // }
      .el-icon-minus,
      .el-icon-plus {
        font-weight: 600;
      }
      .el-input-number__decrease {
        background: #ccdbe0;
        color: #4f7189;
        border: 1px solid #4f7189;
      }
      .el-input-number__increase {
        background: #ffd53d;
        color: #0d183b;
        border: 1px solid #0d183b;
      }
    }
    .need-container {
      margin-top: 18px;
      text-align: center;
      font-size: 16px;
      .need-crystal {
        width: 187px;
        height: 26px;
        // background: rgba(255, 40, 195, 0.2);
        border-radius: 4px;
        line-height: 26px;
        > span {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .need-crystal-number {
        display: inline-block;
        color: #fd68b5;
        font-size: 18px;
        line-height: 18px;
        margin: 0 8px;
        margin-bottom: 4px;
        overflow: hidden;
        max-width: 90px;
        white-space: nowrap;
        vertical-align: middle;
      }
      .crystal-deficiency {
        color: rgb(243, 51, 51);
        font-size: 14px;
        margin: 8px 0 0 20px;
        position: absolute;
      }
    }
    .exchange-butoton {
      width: 170px;
      height: 48px;
      margin-top: 116px;
      background: url(./images/max-exchange.png) no-repeat center;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>
